import { MemoizedSelector, createSelector } from '@ngrx/store';

import { LocationBrief } from '@recruitee/http-types';
import { createEntityCollectionStore, memoizeSelector } from '@recruitee/ngrx';

const {
  namespace,
  actions: defaultActions,
  reducer,
  selectors: { byId },
} = createEntityCollectionStore<{
  locations: LocationBrief[];
  id: string;
}>()('LocationsByCompany');

const actions = {
  fetchOne: defaultActions.fetchOne,
  fetchOneSuccess: defaultActions.fetchOneSuccess,
  fetchOneFailed: defaultActions.fetchOneFailed,
};

const byIdMap = memoizeSelector(
  (companyId: number): MemoizedSelector<any, { [key: number]: LocationBrief } | null> =>
    createSelector(
      byId(companyId),
      state =>
        state?.locations.reduce(
          (acc: { [key: number]: LocationBrief }, location: LocationBrief) => ({
            ...acc,
            [location.id]: location,
          }),
          {},
        ) || null,
    ),
);

const LocationsByCompanySelectors = { byId, byIdMap };

export {
  actions as LocationsByCompanyActions,
  reducer as LocationsByCompanyReducer,
  LocationsByCompanySelectors,
  namespace as LocationsByCompanyNamespace,
};
